export default "/images/ic-phone-a.svg?34924d525544f52ec28102e7e56ebee8";